$(function() {
    var allPanels = $('body.template_expertise  .acc-subpage').hide();

    $('body.template_expertise .expertise-section__more_btn').on('click', function() {
        allPanels.slideUp();
        $(this).parents('.expertise-section').next().slideDown(1200);
        return false;
    });
});